export default __webpack_public_path__ + "static/media/user.25630687.svg";